module.exports = __webpack_public_path__ + "static/img/exhibitor_gold_cn.c3e0819e.png";